import React from 'react'
import parse from 'html-react-parser'
import { Link } from 'gatsby'
import Layout from '../components/layout'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import EubankConferencesSplash from '../../static/img/splash-eubank-xl.jpg'
import EubanksPic from '../../static/img/eubanks-pic.jpg'

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

function BlueButton(props){
  return <div className="col-md-4"><a href={props.link.substr(props.link.lastIndexOf('#'),props.link.length-props.link.lastIndexOf('#'))} className="btn btn-lg btn-outline-info btn-block text-white ml-2 mr-2">{props.text}</a></div>;
}

const Prize = ({ year, name, title, reason }) => (
     <VerticalTimelineElement
          className="vertical-timeline-element--work"
          iconStyle={{ background: '#1560bd', color: '#fff' }}
          icon={`${year}`}
     >
          <div className="card border-0 rounded">
               <div className="card-header">
                    <h3 className="vertical-timeline-element-title text-white">{`${name}`}</h3>
                    <h4 className="vertical-timeline-element-subtitle text-info">{`${title}`}</h4>
               </div>
               <div className="card-body">
                    <p className="text-light mt-0">{`${reason.replace(/(<([^>]+)>)/gi, "")}`}</p>
               </div>
          </div>

     </VerticalTimelineElement>
);
const Conference = ({ year, name, title, link }) => (
     <VerticalTimelineElement
          className="vertical-timeline-element--work"
          iconStyle={{ background: '#1560bd', color: '#fff' }}
          icon={`${year}`}
     >
          <div className="card border-0 rounded">
               <div className="card-header">
                    <h3 className="vertical-timeline-element-title text-white">{`${name}`}</h3>
                    <h4 className="text-info mb-0">{`${title}`}</h4>
               </div>
               <div className="card-body">
                    <p className="m-0 text-center"><a target="_blank" href={`${link}`} className="btn btn-sm btn-success active rounded mt-2">READ MORE</a></p>
               </div>
          </div>

     </VerticalTimelineElement>
);

class EubankConferencesPage extends React.Component {
     constructor(props) {
          super(props);
     }
     render() {
           let content = this.props.data.EubankConferencesPageData;
           let blueButtons = [];
           blueButtons = content.blueButtons.buttons.map((item,key)=>
            <BlueButton key={key} {...item} />
           );
           let conferences = [];
           conferences = content.conferences.map((item,key)=>
              <Conference year={item.year} name={item.title} title={item.subtitle} link={item.button.link} />
            );
            let prizes = [];
            prizes = content.prizes.map((item,key)=>
              <Prize year={item.year} name={item.title} title={item.subtitle} reason={item.description} />
            );
          return (
               <Layout className="eubank-page">

                    <div
                         className="splash jumbotron"
                         style={{ minHeight: '400px', marginBottom: '0px', backgroundImage:`url(${EubankConferencesSplash})`, backgroundSize:'cover', backgroundPosition: 'center center' }}
                    >

                         <h1 className="text-white text-center wow fadeInDown">{parse(content.splash.title)}</h1>
                         <h3 className="text-white text-center wow fadeInRight">- {content.splash.date} - </h3>
                         <p className="text-white text-center wow fadeInLeft">{content.splash.subtitle}</p>
                         <p className="text-white text-center wow fadeInUp mb-0 "><a href={content.splash.button.link} className="btn btn-lg btn-primary pr-5 pl-5 pt-3 pb-3 rounded-0">{content.splash.button.text}</a></p>
                    </div>

                    <div className="container-fluid bg-secondary pt-3 pb-3">
                         <div className="container">
                              <div className="row">
                                   {blueButtons}
                              </div>
                         </div>
                    </div>

                    <div id="previous-conferences" className="container-fluid container-timeline">
                         <div className="container pt-4">

                              <div className="row" id="9th-eubank">
                                   <div className="col-md-12">
                                        <h2 className="text-center text-primary mt-4">Previous Conferences</h2>
                                   </div>
                              </div>

                              <div className="row">
                                   <div className="col-md-12">

                                        <VerticalTimeline>
                                             {conferences}
                                        </VerticalTimeline>
                                   </div>
                              </div>
                         </div>
                    </div>

                    <div id="the-eubanks" className="container container-eubank-history pt-4 pb-4">
                         <div className="row">
                              <div className="col-md-12">
                                   <h2 className="text-center text-primary mt-4">{parse(content.eubanks.title)}</h2>
                              </div>
                         </div>

                         <div className="row">
                              <div className="col-md-12 pt-4">
                                   <img src={content.eubanks.image[0].url} className="float-left mr-4 mb-4" alt={content.eubanks.title} />
                                   {parse(content.eubanks.descriptions)}
                              </div>
                         </div>
                    </div>

                    <div id="prizes" className="container-fluid container-timeline">
                         <div className="container pt-4">

                              <div className="row">
                                   <div className="col-md-12">
                                        <h2 className="text-center text-primary mt-4">Prizes</h2>
                                   </div>
                              </div>
                              <div className="row">
                                   <div className="col-md-12">
                                        <VerticalTimeline>
                                             {prizes}
                                        </VerticalTimeline>
                                   </div>

                              </div>
                         </div>
                    </div>


               </Layout>
          );
     }
}

export default EubankConferencesPage;

export const query = graphql`
     query EubankConferencesPageData {
          EubankConferencesPageData: flamelinkEubankConferencesPageContent {
               splash{
                 title,
                 date,
                 subtitle,
                 button{text,link}
               },
               blueButtons{
                 buttons{text,link}
               },
               conferences{
                 title,
                 subtitle,
                 year,
                 button{text,link}
               },
               eubanks{
                 title,
                 descriptions,
                 image{url}
               },
               prizes{
                 title,
                 subtitle,
                 year,
                 description
               }


          }
     }
`;
